import React, { useState } from 'react';
import { routeHref, routes } from '../data/siteData';

const Navbar = ({ currentPath = '/' }) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <nav className="site-navbar">
      <div className="container-custom">
        <div className="nav-shell flex justify-between items-center gap-6">
          <a href={routeHref('/')} className="flex items-center space-x-3 min-w-0" aria-label="S4 Coconut Exports home">
            <img
              className="site-logo"
              src="/media/logo.svg"
              alt="S4CoconutExports logo"
            />
            <span className="text-lg font-serif font-bold text-secondary hidden sm:inline truncate">S4CoconutExports</span>
            <span className="text-lg font-serif font-bold text-secondary sm:hidden">S4CE</span>
          </a>

          <div className="hidden lg:flex items-center gap-7">
            {routes.map((link) => (
              <a
                key={link.path}
                href={routeHref(link.path)}
                className={`nav-link ${currentPath === link.path ? 'nav-link-active' : ''}`}
              >
                {link.label}
              </a>
            ))}
          </div>

          <button
            onClick={() => setIsOpen((open) => !open)}
            className="lg:hidden flex flex-col space-y-1.5 focus:outline-none"
            aria-label="Toggle menu"
            aria-expanded={isOpen}
          >
            <span className={`w-6 h-0.5 bg-accent transition-all duration-300 ${isOpen ? 'rotate-45 translate-y-2' : ''}`}></span>
            <span className={`w-6 h-0.5 bg-accent transition-all duration-300 ${isOpen ? 'opacity-0' : ''}`}></span>
            <span className={`w-6 h-0.5 bg-accent transition-all duration-300 ${isOpen ? '-rotate-45 -translate-y-2' : ''}`}></span>
          </button>
        </div>

        {isOpen && (
          <div className="mobile-nav-panel lg:hidden animate-slideIn">
            {routes.map((link) => (
              <a
                key={link.path}
                href={routeHref(link.path)}
                className={`block px-4 py-3 text-sm font-semibold transition-colors duration-300 hover:bg-sand/40 hover:text-accent ${currentPath === link.path ? 'bg-sand/30 text-accent' : 'text-secondary'}`}
                onClick={() => setIsOpen(false)}
              >
                {link.label}
              </a>
            ))}
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navbar;
